module.exports = __webpack_public_path__ + "img/T6-C-rc_4.c7059b43.png";